<template>
    <div class="position-relative">
        <v-app class="p-4">

            <div class="mt-20">
                <v-card :loading="loading" class="p-3 pt-0 mt-4">

                    <terminal-table class="col-12" :currentPage="datas.current_page"
                                    :perPage="datas.per_page" v-if="isMobile" :getData="getTableData"
                                    :pageCount="datas.last_page"
                                    :options="tableProps" :datas="datas" :headers="columns"></terminal-table>


                    <data-table
                            v-else
                            :data="datas"
                            :columns="columns"
                            :debounce-delay="3000"
                            :translate="translate"
                            :pagination="paginate"
                            :orderBy="tableProps.column"
                            :orderDir="tableProps.dir"
                            :per-page="[10, 25, 50, 100, 500]"
                            @on-table-props-changed="reloadTable"
                            class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                    ></data-table>
                </v-card>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "../uiBeautifier/titleRibbon";
import {Axios2, Bus, dataTableProps} from "../../../main";
import {debounce} from "../../../custom";
import button from "../button";

export default {
    name: "fileManager",
    components: {TitleRibbon},
    data() {
        return {
            tableProps: dataTableProps.tableProps,
            translate: dataTableProps.translate,
            paginate: dataTableProps.pagination,
            datas: null,
            BankModal: null,
            infos: null,
            columns: [
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'کاربر',
                    name: 'user',
                },
                {
                    label: 'عنوان',
                    name: 'title',
                },
                {
                    label: 'دسته‌بندی',
                    name: 'category',
                    primary:true,
                },
                {
                    label: 'IP',
                    name: 'ip',
                },
                {
                    label: 'مرورگر',
                    name: 'agent',
                },
                {
                    label: 'تاریخ دانلود',
                    name: 'created_at_p',
                },
            ],
            loading: false
        }
    },
    methods: {
        getTableData(url = this.url, query = this.tableProps) {
            this.loading = true;
            Axios2.get("/admin/archive/downloaded", {
                params: query
            }).then((res) => {
                this.datas = res.data.data;
                this.loading = false;
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.tableProps.page = this.datas.current_page;
                this.getTableData(this.url, tableProps);
            }, 1000);
        },
    },
    created() {
        this.getTableData();

        Bus.$on("reload", () => {
            this.reloadTable(this.tableProps);
        })
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getTableData(this.url);
                    return true
                case 'sm':
                    this.getTableData(this.url);
                    return true
                case 'md':
                    this.getTableData(this.url);
                    return false
                case 'lg':
                    this.getTableData(this.url);
                    return false
                case 'xl':
                    this.getTableData(this.url);
                    return false
            }
        },
    },
}
</script>

<style scoped>

</style>